import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { TimeService } from '../../../shared/services/time.service';
import { SelectOptionsService } from '../../../shared/services/selectoptions.service';
import moment from 'moment';

@Component({
  selector: 'deposit-funds',
  template: require('./deposit-funds.component.html')
})

export class DepositFundsComponent extends BaseRoute {

  constructor(injector: Injector, timeService: TimeService, optionsService: SelectOptionsService) {
    super(injector);

    this.timeService = timeService;
    this.optionsService = optionsService;
    // this._testHelper();

    // To account
    const fromAccount = this.form.inputs.fromAccount;
    const toAccount = this.form.inputs.toAccount;
    const contributionLabel = this.form.inputs.contributionYearLabel;
    const contributionYear = this.form.inputs.contributionYear;

    // Uncomment and add it as the default fundAccount below to test
    // const defaultAccount = { accountNumber: '123434' };

    const fundAccount = this.appActions.getData('FundAccount');
    const maskedAccount = fundAccount.accountNumber.replace(/\d(?=\d{4})/g, '*');
    const formattedAccount = `${fundAccount.accountHoldersName} ${maskedAccount}`;
    this.flowManager.isOneAllyBank = fundAccount.allyBankAccount === true;

    // Used in review page
    this.appActions.setData('DepositFunds.from', formattedAccount);

    // Update noneditables
    const toAccountNumber = this.appActions.getData('DepositFunds.to');
    fromAccount.noneditable = formattedAccount;
    toAccount.noneditable = toAccountNumber;

    // Update default deposit date
    const depositDateValue = this.timeService.getDepositDate(this.flowManager.isOneAllyBank);
    this.appActions.setData('DepositFunds.date', depositDateValue);

    if (contributionLabel !== undefined) {
      // Contribution year label
      const today = moment();
      const configTaxDate = this.flowManager.config.ira.currentTaxEndDate.split('/');
      const currentYear = configTaxDate[2];
      contributionLabel.noneditable = currentYear;

      contributionYear.options = [
        { id: currentYear, name: currentYear }
      ];

      contributionYear.defaultValue = currentYear;
      const M = parseInt(configTaxDate[0], 10) - 1; // because moment wants 0 indexed month int 0 - Jan, 1 - Feb
      const taxFilingEndDate = moment({
        y: currentYear,
        M,
        d: configTaxDate[1],
        h: 14,
        m: 55
      });

      if (today.isBefore(taxFilingEndDate)) {
        contributionYear.showUp = true;
        contributionYear.require = true;
        contributionLabel.showUp = false;
        contributionYear.options.push({ id: currentYear - 1, name: currentYear - 1 });
      } else {
        contributionLabel.showUp = true;
        this.appActions.setData('DepositFunds.contributionYear', currentYear);
      }
    }
  }

  _testHelper() {
    // Debugging only
    // this.appActions.setData('FundAccount', { accountNumber: '12345' });
    // const toFunds = this.appActions.getData('DepositFunds.to');
    // if (toFunds == null) {
    //   this.appActions.setData('DepositFunds.to', '60921595');
    // }

    // const forTransfer = this.appActions.getData('ForTransfer');
    // if (forTransfer == null) {
    //   this.appActions.setData('ForTransfer', {
    //     accountType: 'Individual',
    //     bankAccountType: 'Checking', // Needs mapping
    //     routingNumber: '999999963', // Static for ally
    //     accountNumber: '1313',
    //     bankName: 'DagSecurityQA', // Need more accurate bank name
    //     name: 'AccountNameFromACM',
    //     accountHoldersName: 'First Last',
    //     allyBankAccount: false
    //   });
    // }
  }

  showRecurring(bool) {
    this.flowManager.isRecurringDeposit = bool;
    this.form.inputs.depositDate.label = bool ? 'Deliver first transfer on' : 'Deliver on';
  }

  updateOptionValue(event) {
    const year = this.flowManager.config.ira.currentTaxEndDate.split('/')[2];
    if (this.flowManager.isOneAllyBank === true) {
      if (event.id === 'depositFrequency') {
        this.showRecurring(event.value !== this.optionsService.optionTypes.frequency.ONE_TIME.name);
      }
    }
    if (event.id === 'contributionYear') {
      const depositFrequency = this.form.inputs.depositFrequency;
      const selectOptions = this.optionsService.getSelectOptions(depositFrequency.optionsType);
      if (event.value < year) {
        depositFrequency.options = selectOptions.filter(
          i => i.code === this.optionsService.optionTypes.frequency.ONE_TIME.code);
      } else {
        depositFrequency.options = selectOptions;
      }
    }
  }

  openModal() {
    this.modal.transferTimes();
  }

  btnClick(e) {
    if (e.action === 'fund_later') {
      if (this.flowManager.isAuthed) {
        this.flowManager.ssoToAlly();
      } else {
        this.router.navigate(['/credentials']);
      }
      return;
    }

    this.handleClick(e.action);
  }
}
